export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";
export const CHANGE_LAST_VISITED = "CHANGE_LAST_VISITED";
export const ADD_TOAST_MSG = "ADD_TOAST_MSG";
export const REMOVE_TOAST_MSG = "REMOVE_TOAST_MSG";
